var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserCampaignTable',{attrs:{"accompagnements":_vm.accompagnements},on:{"loadAsyncData":_vm.loadAsyncData}})
}
var staticRenderFns = []

export { render, staticRenderFns }